import React from 'react';
import { Asset } from '../../../types/asset';

interface CollageProps {
    title: string;
    imageOne: Asset;
    imageTwo: Asset;
    imageThree: Asset;
    imageFour: Asset;
    imageFive: Asset;
}

export const Collage: React.FC<CollageProps> = ({
    title,
    imageOne,
    imageTwo,
    imageThree,
    imageFour,
    imageFive,
}) => {
    return (
        <div className={'py-20 border-black border-b  px-6'}>
            <h3 className={'text-center pb-16 '}>{title}</h3>
            <div className={'grid overflow-hidden md:grid-cols-3 gap-2 md:gap-6 max-w-5xl mx-auto'}>
                <div className={'md:row-start-1 md:row-end-1 md:col-start-1 md:col-end-2 bg-gray-400'}>
                    <img src={imageOne.url} alt={imageOne.name} className={'object-cover w-full h-full'}/>
                </div>
                <div className={'md:row-start-1 md:row-end-1 md:col-start-2 md:col-end-4 bg-gray-400'}>
                    <img src={imageTwo.url} alt={imageOne.name} className={'object-cover w-full h-full'}/>
                </div>
                <div className={'md:row-start-2 md:row-end-4 md:col-start-1 md:col-end-3 bg-gray-400'}>
                    <img src={imageThree.url} alt={imageOne.name} className={'object-cover w-full h-full'}/>
                </div>
                <div className={'md:row-start-2 md:row-end-3 md:col-start-3 md:col-end-4 bg-gray-400'}>
                    <img src={imageFour.url} alt={imageOne.name} className={'object-cover w-full h-full'}/>
                </div>
                <div className={'md:row-start-3 md:row-end-4 md:col-start-3 md:col-end-4 bg-gray-400'}>
                    <img src={imageFive.url} alt={imageOne.name} className={'object-cover w-full h-full'}/>
                </div>
            </div>
        </div>
    );
};
